<div class="workflow-application-notes">
  <div class="notes-header">
    <h5>Application Notes</h5>
    <div class="application-info" *ngIf="applicationNumber">
      <span class="label">Application #:</span>
      <span class="value">{{ applicationNumber }}</span>
    </div>
  </div>

  <!-- Add New Note Section -->
  <div class="add-note-section">
    <div class="form-group">
      <label for="newNote">Add Note</label>
      <textarea
        id="newNote"
        class="form-control"
        rows="3"
        [(ngModel)]="newNote"
        placeholder="Enter a new note..."
        [disabled]="isSaving">
      </textarea>
    </div>
    <div class="button-group">
      <button
        class="btn btn-primary"
        (click)="addNote()"
        [disabled]="!newNote || !newNote.trim() || isSaving">
        <i class="fa fa-plus"></i> Add Note
      </button>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="isLoading" class="text-center py-3">
    <i class="fa fa-spinner fa-spin"></i> Loading notes...
  </div>

  <!-- Notes List -->
  <div *ngIf="!isLoading" class="notes-list">
    <div *ngIf="notes.length === 0" class="no-notes text-muted text-center py-3">
      No notes yet. Add your first note above.
    </div>

    <div *ngFor="let note of notes" class="note-item card mb-3" [ngClass]="{'unread-note': !note.isReadByCurrentUser}">
      <div class="card-body">
        <!-- View Mode -->
        <div *ngIf="editingNoteId !== note.id">
          <div class="note-header d-flex justify-content-between align-items-start mb-2">
            <div class="note-content flex-grow-1">
              {{ note.note }}
            </div>
            <span *ngIf="!note.isReadByCurrentUser && note.createdBy !== currentUserName" class="badge bg-warning text-dark ms-2">Unread</span>
            <span *ngIf="note.isReadByCurrentUser" class="badge bg-success ms-2">Read</span>
          </div>
          <div class="note-metadata">
            <small class="text-muted">
              <strong>{{ note.modifiedBy }}</strong>
              <span *ngIf="note.modifiedOnString">on {{ note.modifiedOnString }}</span>
              <span *ngIf="!note.modifiedOnString && note.modifiedOn">on {{ note.modifiedOn | date:'short' }}</span>
            </small>
          </div>
          <div class="note-actions mt-2">
            <button
              *ngIf="canMarkAsRead(note)"
              class="btn btn-sm btn-outline-success me-2"
              (click)="markAsRead(note)"
              [disabled]="isSaving">
              <i class="fa fa-check"></i> Mark as Read
            </button>
            <button
              class="btn btn-sm btn-outline-primary me-2"
              (click)="startEdit(note)"
              [disabled]="isSaving">
              <i class="fa fa-edit"></i> Edit
            </button>
            <button
              class="btn btn-sm btn-outline-danger"
              (click)="deleteNote(note.id)"
              [disabled]="isSaving">
              <i class="fa fa-trash"></i> Delete
            </button>
          </div>
        </div>

        <!-- Edit Mode -->
        <div *ngIf="editingNoteId === note.id">
          <div class="form-group">
            <textarea
              class="form-control"
              rows="3"
              [(ngModel)]="editingNoteText"
              [disabled]="isSaving">
            </textarea>
          </div>
          <div class="note-actions mt-2">
            <button
              class="btn btn-sm btn-success me-2"
              (click)="saveEdit(note)"
              [disabled]="!editingNoteText || !editingNoteText.trim() || isSaving">
              <i class="fa fa-check"></i> Save
            </button>
            <button
              class="btn btn-sm btn-secondary"
              (click)="cancelEdit()"
              [disabled]="isSaving">
              <i class="fa fa-times"></i> Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
